import { useMemo } from 'react';
import type { ChartId } from '../catalog/chartCatalog';
import type { AnalyticsChart, ChartResult } from '../catalog/types';
import { selectChartById } from '../model/selectChartsForSection';
import { useCurrentUserInProject } from 'store/user';
import { useBuildChartContext } from './useBuildChartContext';
import { useChartResultsMap } from './useChartResultsMap';

export function useChartResult(id: ChartId): ChartResult | undefined {
  return useChartResultsMap()[id];
}

export function useAnalyticsChart(id: ChartId): AnalyticsChart | undefined {
  const resultsMap = useChartResultsMap();
  const user = useCurrentUserInProject();
  const ctx = useBuildChartContext();

  return useMemo(
    () => selectChartById(id, resultsMap, user, ctx),
    [id, resultsMap, user, ctx]
  );
}
